import fixture from './BuyerCheckToken.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IBuyerCheckTokenClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerCheckTokenClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class BuyerCheckTokenClient implements IBuyerCheckTokenClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, addLoginCount, mock = false } = input;
        const PATH = `${API_LOCATION_URL}/buyer/user/check_token?login_count=${addLoginCount}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
